import { useDispatch, useSelector } from 'react-redux';
import { replaceSubstitute, updateOOSCurrentItemIndex } from '../redux/actions/substitutes.action';
import { IAppState } from 'config/redux/reducers';
import { useState } from 'react';
import { INewCartEntry } from '../ICart';
import { ISubstitutesShipment } from '../ISubstitutes.types';
import TrackerSubstitution from 'utils/Tracker.substitution';

const useOOSChooseReplacement = ({
  substitutesShipment,
}: {
  substitutesShipment?: ISubstitutesShipment;
}) => {
  const dispatch = useDispatch();

  const [substituteQty, setSubstituteQty] = useState(0);

  const {
    oosSelectedItemsIds,
    oosCurrentItemIndex,
    errorSubstituteReplacement,
    loadingSubstituteReplacement,
  } = useSelector((state: IAppState) => state.newCart);

  const currentOOSProductId = oosSelectedItemsIds[oosCurrentItemIndex];

  const { originalProduct = {} as INewCartEntry, substitutes: productSubstitutes = [] } =
    (substitutesShipment &&
      substitutesShipment.eligibleItems &&
      substitutesShipment.eligibleItems.find(
        item => String(item.originalProduct.entryNumber) === String(currentOOSProductId)
      )) ||
    {};

  const onSkip = () => {
    dispatch(updateOOSCurrentItemIndex(oosCurrentItemIndex + 1));
    TrackerSubstitution.chooseSubstituteSkipBtnTracking();
  };

  const onContinue = (selectedSubstituteProductId: string) => {
    const selectedSubstituteProduct = productSubstitutes.find(
      p => String(p.entryNumber) === selectedSubstituteProductId
    );
    if (selectedSubstituteProduct) {
      dispatch(
        replaceSubstitute(
          originalProduct,
          { ...selectedSubstituteProduct, quantity: substituteQty },
          oosCurrentItemIndex
        )
      );
      TrackerSubstitution.chooseSubstituteATCBtnTracking();
    }
  };

  return {
    totalOOSSelectedProductCount: oosSelectedItemsIds.length,
    currentOOSProductCount: oosCurrentItemIndex + 1,
    originalProduct,
    productSubstitutes,
    errorSubstituteReplacement,
    loadingSubstituteReplacement,
    substituteQty,
    onSkip,
    onContinue,
    onSubstituteQtyChange: (qty: number) => setSubstituteQty(qty),
  };
};

export default useOOSChooseReplacement;
